<template>
  <div></div>
</template>
<script>
export default {
  components: {},
  mixins: [],
  mounted () {
    this.$store.dispatch('TSZ/logout');
    this.$router.push('/login');
    this.$router.go();
  },
  props: {},
  data () {
    return {};
  },
  methods: {},
  computed: {},
  watch: {}
};
</script>
<style lang='scss' scoped>
</style>
